import React from 'react';
import { Edit } from 'react-admin';
import { t } from 'i18next';

import EditFormTitle from '../EditFormTitle';
import { CustomEditToolbar } from '../CustomEditToolbar';
import { EmailTemplateForm } from './EmailTemplateForm';

export const EmailTemplateEdit = props => (
  <Edit {...props} title={<EditFormTitle formName={t('email_templates.template')} />}>
    <EmailTemplateForm toolbar={<CustomEditToolbar user={props.options.currentUser.role}/>}/>
  </Edit>
);